<template>
  <div class="main">
    <img class="notice-img" src="@/assets/notion-ic.png" />
    <p class="text-line1">
      현재 서비스 이용이 원활하지 않습니다<br />잠시 후 앱을 재실행해 주세요
    </p>
    <p class="text-line2">code : {{ errorCode || 0 }}</p>
    <div class="btn-area">
      <button
        class="home-btn"
        :class="{ focused: focusIndex == 1 }"
        @click="goHome"
      >
        홈으로
      </button>
      <button
        class="close-btn"
        :class="{ focused: focusIndex == 2 }"
        @click="enterKeyProc"
        ref="button"
      >
        종료하기
      </button>
    </div>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js";

export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 1,
    };
  },

  props: ["errorCode"],

  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
  },

  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "Enter":
            if (this.focusIndex === 1) {
              this.goHome();
            } else {
              // 앱 종료
              this.enterKeyProc(val);
            }
            break;
          case "ArrowLeft":
            this.focusIndex = 1;
            break;
          case "ArrowRight":
            this.focusIndex = 2;
            break;
        }
      }
    },
  },

  methods: {
    enterKeyProc(keyInput) {
      deviceApi.stopApplication();
    },
    goHome() {
      this.$store.commit("SET_USER_INFO", {});
      this.$router.replace({
        name: "intro",
        params: {
          t: new Date().getTime(),
        },
      });
    },
  },

  created() {
    // this.$store.dispatch("REQUEST_LOGOUT");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  margin-top: 310px;
  text-align: center;
}
.notice-img {
  width: 128px;
  height: 128px;
}
.text-line1 {
  font-size: 56px;
  line-height: 1.29;
  color: #eeeeee;
  margin-top: 40px;
  margin-bottom: 30px;
}
.text-line2 {
  font-size: 40px;
  line-height: 1;
  color: #888888;
}

.btn-area {
  display: flex;
  justify-content: center;
}

button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 40px;
  border: none;
}

.close-btn {
  margin-left: 40px;
}

button.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    margin-top: 190px;
  }
  .notice-img {
    width: 64px;
    height: 64px;
  }
  .text-line1 {
    font-size: 32px;
    line-height: 1.5;
    color: #ffffff;
    margin-top: 32px;
    margin-bottom: 24px;
    font-weight: bold;
  }
  .text-line2 {
    font-size: 20px;
    line-height: 1;
    color: #888888;
    font-weight: bold;
  }
  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    color: #ffffff;
    margin-top: 48px;
    border: none;
    font-weight: bold;
  }

  .close-btn {
    margin-left: 20px;
  }

  button.focused {
    border: solid 3px #ffffff;
  }
}
</style>
